import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import Vuelidate from "vuelidate";
import moment from "moment";

// Leaflet
import "leaflet/dist/leaflet.css";

const L = require("leaflet");

// changes so that leaflet's images work after going through webpack
import marker from "leaflet/dist/images/marker-icon.png";
import marker2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Added by Marina on Feb. 9, 2022:
Vue.prototype.$appUrl = process.env.NODE_ENV === "development" ? location.protocol + "//" + location.hostname + ":" + location.port : location.protocol + "//" + location.hostname;

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: marker2x,
  iconUrl: marker,
  shadowUrl: markerShadow
});

Vue.use(Vuelidate);
Vue.config.productionTip = false;

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas, faBars } from "@fortawesome/free-solid-svg-icons";
library.add(fas, faBars);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";


Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY");
  }
});

Vue.filter("formatDateTime", function(value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY h:mm A");
  }
});

Vue.filter("trueOrFalse", function(value) {
  if (value) {
    return "Yes";
  }
  return "No";
});

Vue.filter("number", function(value, precision) {
  return value.toFixed(precision);
});

Vue.filter("percentage", function(value, precision = 2) {
  if (value) {
    return (value * 100).toFixed(precision);
  }
  return value;
});



Vue.use(BootstrapVue);
require("toastr/toastr.scss");

import "./css/asu.css";
import "./css/site.css";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
